export const getNominationRoundYear = (currentDate = new Date()) => {
  const currentMonth = currentDate.getMonth() + 1; // Month is zero-based, so we add 1

  if (currentMonth >= 1 && currentMonth <= 6) {
    return currentDate.getFullYear(); // Return current year if current month is between January and June
  }
  return currentDate.getFullYear() + 1; // Return next year if current month is between July and December
};
